import $axios from '../services/apiLms.js'

const state = () => ({
    // presences: {
    //     "S": 0,
    //     "I": 0,
    //     "A": 0,
    //     "others": 0
    // },
    // presences_detail: [],
    presences_by_month: {},
    presences_by_date: {}
})

const mutations = {
    // ASSIGN_PRESENCES(state, payload) {
    //     state.presences = payload
    // },
    // ASSIGN_PRESENCES_DETAIL(state, payload) {
    //     state.presences_detail = payload
    // },
    ASSIGN_PRESENCES_BY_MONTH(state, payload) {
        state.presences_by_month = payload
    },
    ASSIGN_PRESENCES_BY_DATE(state, payload) {
        state.presences_by_date = payload
    },
}

const actions = {
    getPresencesByMonth({ commit }, date) {
        return new Promise((resolve) => {
            $axios.get(`ortu/presensi/month?month=${date.month}&year=${date.year}`)
                .then((response) => {
                    commit('ASSIGN_PRESENCES_BY_MONTH', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getPresencesByDate({ commit }, date) {
        return new Promise((resolve) => {
            $axios.get(`ortu/presensi/day?date=${date}`)
                .then((response) => {
                    commit('ASSIGN_PRESENCES_BY_DATE', response.data.data)
                    resolve(response.data)
                })
        })
    },
    // getPresences({ commit }, date) {
    //     return new Promise((resolve) => {
    //         $axios.get(`kepsek/presensi?date=${date}`)
    //             .then((response) => {
    //                 commit('ASSIGN_PRESENCES', response.data.data)
    //                 resolve(response.data)
    //             })
    //     })
    // },
    // getPresencesDetail({ commit }, date) {
    //     return new Promise((resolve) => {
    //         $axios.get(`kepsek/presensi/detail?date=${date}`)
    //             .then((response) => {
    //                 commit('ASSIGN_PRESENCES_DETAIL', response.data.data)
    //                 resolve(response.data)
    //             })
    //     })
    // },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}